import { createStyles } from '@material-ui/core/styles';

import { colors } from '../colors';

export default createStyles({
  colorPrimary: {
    '&.MuiSwitch-switchBase': {
      left: 3,
    },
    '&.Mui-checked': {
      left: -3,
    },
    '& .MuiIconButton-label .MuiSwitch-thumb': {
      backgroundColor: colors.gray,
      opacity: 1,
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      backgroundColor: colors.gray,
      opacity: 0.5,
    },
    '&.Mui-checked .MuiIconButton-label .MuiSwitch-thumb': {
      backgroundColor: 'currentColor',
    },
    '& + .MuiSwitch-track': {
      backgroundColor: colors.darkGray,
      maxWidth: 34,
    },
    '&.Mui-checked + .MuiSwitch-track': {
      backgroundColor: colors.purple,
      opacity: 1,
    },
  },
});
